module.exports = __webpack_public_path__ + "res/20-img_game_bg_r.14a65b7de0c3b28981ad3086923bd716.png";